import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSmile = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M1.5 9C1.5 4.85787 4.85787 1.5 9 1.5C13.1421 1.5 16.5 4.85787 16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85787 16.5 1.5 13.1421 1.5 9ZM6.95455 7.97727C7.51938 7.97727 7.97727 7.51938 7.97727 6.95455C7.97727 6.38971 7.51938 5.93182 6.95455 5.93182C6.38971 5.93182 5.93182 6.38971 5.93182 6.95455C5.93182 7.51938 6.38971 7.97727 6.95455 7.97727ZM5.86358 10.5001C6.16388 10.2748 6.5895 10.3348 6.81599 10.6336L6.81915 10.6376C6.82321 10.6427 6.83092 10.6523 6.8422 10.6658C6.8648 10.6927 6.90144 10.7347 6.95138 10.7868C7.0518 10.8916 7.20272 11.0338 7.39813 11.1759C7.79161 11.462 8.3355 11.7273 8.99993 11.7273C9.66436 11.7273 10.2083 11.462 10.6017 11.1759C10.7972 11.0338 10.9481 10.8916 11.0485 10.7868C11.0984 10.7347 11.1351 10.6927 11.1577 10.6658C11.169 10.6523 11.1767 10.6427 11.1807 10.6376L11.1839 10.6336C11.4104 10.3348 11.836 10.2748 12.1363 10.5001C12.4375 10.726 12.4986 11.1533 12.2727 11.4546L12.272 11.4555C12.199 11.5524 12.1169 11.6429 12.0331 11.7303C11.8885 11.8812 11.6772 12.0799 11.4038 12.2787C10.8598 12.6744 10.04 13.091 8.99993 13.091C7.95982 13.091 7.14013 12.6744 6.59608 12.2787C6.32274 12.0799 6.11144 11.8812 5.96684 11.7303C5.88329 11.6431 5.80169 11.5529 5.72869 11.4565C5.50469 11.1589 5.56513 10.7239 5.86358 10.5001ZM12.0682 6.95455C12.0682 7.51938 11.6103 7.97727 11.0455 7.97727C10.4806 7.97727 10.0227 7.51938 10.0227 6.95455C10.0227 6.38971 10.4806 5.93182 11.0455 5.93182C11.6103 5.93182 12.0682 6.38971 12.0682 6.95455Z",
		fill: "black",
		fillOpacity: .6
	})]
});
const ForwardRef = forwardRef(SvgSmile);
export { ForwardRef as ReactComponent };
